import {
  MaterialReactTable,
  useMaterialReactTable,
} from "material-react-table";
import React from "react";
import { DrawingBomContext } from "../../DrawingBomContext";
import { groupingPlatesTableCols } from "./cols";
import {
  bulkDescriptionMrqMaterialsColsEdit,
  taggedMrqMaterialsColsEdit,
} from "../../../Components/cols/mrqMaterialsCols";
import { lightTable } from "../../../../../../../../../styles/muiProps";

export default function GroupingTable({
  consolidatedMaterials,
  mrqMaterials,
  setMrqMaterials,
}) {
  const isTaggedMaterials =
    consolidatedMaterials?.some(
      (row) => row?.tagNumber && String(row.tagNumber).trim() !== "-",
    ) ?? false;

  const isMaterialCodeMaterials =
    consolidatedMaterials?.some(
      (row) => row?.materialCode && String(row.materialCode).trim() !== "-",
    ) ?? false;

  const onChange = (e, row) => {
    e.preventDefault();
    const { name, value } = e.target;
    console.log("edit:", { [name]: value }, row);

    const updatedMaterials = mrqMaterials.map((m) => {
      if (m.id === row.id) {
        return { ...m, [name]: value };
      } else {
        return m;
      }
    });
    console.log("updatedMaterials", row.id, updatedMaterials);
    setMrqMaterials(updatedMaterials);
  };

  // console.log("mrq Materials:", mrqMaterials);

  const table = useMaterialReactTable({
    columns: isTaggedMaterials
      ? taggedMrqMaterialsColsEdit(onChange)
      : isMaterialCodeMaterials
        ? groupingPlatesTableCols
        : bulkDescriptionMrqMaterialsColsEdit(onChange),

    // data: isTaggedMaterials
    //   ? consolidatedTaggedMaterialsData
    //   : isMaterialCodeMaterials
    //   ? consolidatedMaterialsData
    //   : mrqMaterials,
    data: mrqMaterials,
    enableStickyHeader: true,
    ...lightTable,

    muiTableContainerProps: {
      sx: { maxHeight: isTaggedMaterials ? "350px" : "450px" },
    },
  });

  return <MaterialReactTable table={table} />;
}
